import type { MailboxInfo } from 'owa-client-types';
import getMailboxRequestOptions from 'owa-service/lib/getMailboxRequestOptions';
import type GetItemJsonRequest from 'owa-service/lib/contract/GetItemJsonRequest';
import type GetItemJsonResponse from 'owa-service/lib/contract/GetItemJsonResponse';
import type RequestOptions from 'owa-service/lib/RequestOptions';
import type GetItemScenario from './GetItemScenario';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * This is the one canonical place allowed to import getItemOperation directly.
 * All other callers must use trackedGetItemOperation from this file. */
import getItemOperation from 'owa-service/lib/operation/getItemOperation';

/**
 * Tracked wrapper around getItemOperation for callers outside the GQL resolver path.
 * Passes scenarioSource via RequestOptions so that captureServiceActionOptics
 * logs it automatically in the client_network_request table.
 *
 * @param mailboxInfo - The mailbox context; passed to getMailboxRequestOptions automatically
 * @param scenario - Identifies the call site; logged as scenarioSource in client_network_request
 * @param req - The GetItem request body
 * @param additionalOptions - Extra RequestOptions merged with mailboxInfo via getMailboxRequestOptions
 */
export function trackedGetItemOperation(
    mailboxInfo: MailboxInfo | undefined,
    scenario: GetItemScenario,
    req: GetItemJsonRequest,
    additionalOptions?: RequestOptions
): Promise<GetItemJsonResponse> {
    return getItemOperation(
        req,
        getMailboxRequestOptions(mailboxInfo, {
            ...additionalOptions,
            scenarioSource: scenario,
        })
    );
}
